import React from "react";
import { IconBaseProps } from "react-icons";

export const SpeedSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill={fill}
    fillRule="evenodd"
  >
    <path d="M1.092 15.274c-.092 1.79.093 3.668.739 5.458l2.677-1.61c-.37-1.254-.462-2.596-.37-3.848H1.092zM3.123 9.458C2.2 10.889 1.553 12.5 1.277 14.11h3.046a10.52 10.52 0 0 1 1.385-3.132L3.123 9.458zM7.185 5.521c-1.293.716-2.493 1.79-3.416 3.042l2.585 1.521c.738-.716 1.477-1.342 2.4-1.879l-1.57-2.684zM12.354 4a13.39 13.39 0 0 0-4.154.984l1.477 2.774a9.686 9.686 0 0 1 2.677-.626V4zM17.708 4.984c-1.385-.537-2.77-.895-4.246-.984v3.132c.923.09 1.846.268 2.676.626l1.57-2.774zM22.138 8.563c-1.015-1.252-2.215-2.326-3.507-3.042l-1.477 2.684c.83.537 1.661 1.163 2.308 1.88l2.676-1.522zM24.538 14.11c-.276-1.61-.83-3.22-1.846-4.652l-2.584 1.52a10.52 10.52 0 0 1 1.384 3.133h3.046zM23.985 20.732c.646-1.79.923-3.669.738-5.458h-3.046c.185 1.252.092 2.594-.37 3.847l2.678 1.61zM16.877 10.174c-1.108 1.342-5.262 5.458-5.723 6.263-.462.805-.185 1.79.646 2.237.83.447 1.846.179 2.308-.627.461-.715 2.123-6.263 2.769-7.873zm-3.785 6.263c-1.107-.626-2.123 1.074-1.015 1.7 1.2.716 2.215-1.074 1.015-1.7z" />
  </svg>
);
